import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4486985a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "取引担当者", -1))

import { ref, withDefaults, watch, computed } from "vue";
import BaseModal from "@/components/common/BaseModal.vue";
import Select from "@/components/common/form/Select.vue";
import Btn from "@/components/common/Btn.vue";
import Loading from "@/components/common/Loading.vue";
import CompanyInvoiceApi from "@/api/company-invoice";
import OperatorApi from "@/api/operator";
import { ICompanyInvoice } from "@/models/company-invoice";
import { IOperator } from "@/models/operator";

interface IProps {
  companyInvoice: ICompanyInvoice;
  visible: boolean;
  headerText?: string;
  onClose?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeOperatorModal',
  props: {
    companyInvoice: {},
    visible: { type: Boolean, default: false },
    headerText: {},
    onClose: { type: Function, default: () => {
    return;
  } }
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(false);
const operators = ref<IOperator[]>([]);

watch(
  () => props.visible,
  async (visible) => {
    if (visible) {
      isLoading.value = true;
      await OperatorApi.getOperators().then((res) => {
        operators.value = res;
      });
      isLoading.value = false;
    } else {
      operators.value = [];
    }
  }
);

const operatorId = ref(props.companyInvoice.cs_operator_id);

const operatorOptions = computed(() => {
  return operators.value.map((operator) => {
    return {
      value: operator.id,
      label: operator.name,
    };
  });
});

const onSubmit = async () => {
  if (isLoading.value) return;

  await CompanyInvoiceApi.updateCsOperator(
    props.companyInvoice.id,
    operatorId.value
  ).then(() => {
    // reload する
    location.reload();
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "header-text": "取引担当者を変更",
    visible: _ctx.visible,
    "on-close": _ctx.onClose
  }, {
    footer: _withCtx(() => [
      _createVNode(Btn, {
        text: "キャンセル",
        "btn-type": "btn-gray",
        "on-click-event": _ctx.onClose,
        class: "cancel-btn"
      }, null, 8, ["on-click-event"]),
      _createVNode(Btn, {
        text: "決定",
        "btn-type": "btn-primary",
        "on-click-event": onSubmit,
        class: "submit-btn",
        disabled: isLoading.value
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (isLoading.value)
        ? (_openBlock(), _createBlock(Loading, {
            key: 0,
            "is-loading": isLoading.value,
            "is-fixed": ""
          }, null, 8, ["is-loading"]))
        : _createCommentVNode("", true),
      _createVNode(Select, {
        modelValue: operatorId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((operatorId).value = $event)),
        options: operatorOptions.value,
        placeholder: "取引担当者を選択してください"
      }, null, 8, ["modelValue", "options"])
    ]),
    _: 1
  }, 8, ["visible", "on-close"]))
}
}

})